import { gql } from '@apollo/client'

const PATCH_MEMBER = gql`
  mutation member($documentNumber: ID!, $member: MemberInput!) {
    member(documentNumber: $documentNumber, member: $member) {
      statusCode
      code
      error
      message
    }
  }
`

export default PATCH_MEMBER
